define('MM/Components/ContentSearch/FacetCascadedPanel',[
    "jquery",
    "knockout",
    "underscore",
    "MM/Models/ContentSearch/FacetDropdownViewModel",
    "MM/Models/ContentSearch/FacetCascadedValue",
    "eventManager"
], function ($, ko, _, FacetDropdownViewModel, FacetCascadedValue, eventManager) {
    "use strict";

    var searchLogic = ["and", "or_total_count", "or_incremental_count"];

    function FacetCascadedPanel(panelElement, allPreselected) {

        var facetPanel = $(panelElement).data('facet');
        if (facetPanel != null) {
            // prevent assigning facet panel twice to the same element.
            return facetPanel;
        }

        var $dataEl = $(".js-facet", panelElement),
            title = $dataEl.data("title"),
            titleText = $dataEl.data("title-text"),
            searchLogicType = $dataEl.data("search-logic-type").toLowerCase(),
            preselectedValueByBackend = $dataEl.data("preselected-value") || "",
            preselectedByTitle = allPreselected[title] || "",
            preselectedCount = preselectedByTitle instanceof Array ? preselectedByTitle.length : 0,
            initialSelectedOptionText = $dataEl.data("placeholder"),
            facets = [],
            self = this;

        // if preselected by rendering parameters exists and url has hash (expected hash from parent dropdown) and hash doesn't has preselected by rendering parameters value
        if (preselectedValueByBackend && window.location.hash && window.location.hash.indexOf(preselectedValueByBackend) === -1) {
            window.location.hash = window.location.hash + "," + encodeURIComponent(title) + ":" + preselectedValueByBackend;
        }

        var viewModel = new FacetDropdownViewModel(initialSelectedOptionText);
        ko.applyBindings(viewModel, $(".dropdown-toggle", panelElement).get(0));
        ko.applyBindings(viewModel, $(".title", panelElement).get(0));

        $(".js-row", panelElement).each(function () {
            var $el = $(this),
                id = $el.data("id"),
                val = String($el.data("value")),
                parent = $el.data("parent"),
                text = $el.find('.score-facet-value').text(),
                isParentPreSelected = false,
                isPreSelected = val !== "" && (preselectedByTitle.indexOf(val) > -1 || (preselectedCount === 1 && preselectedValueByBackend.indexOf(val) > -1));

            if (allPreselected[title]) {
                allPreselected[title].map(function (element, index) {
                    if (element == parent) {
                        isParentPreSelected = true;
                    }
                });
            }

            if (!isParentPreSelected) {
                isPreSelected = false;
            }

            // preselectedCount === 1 - we must have at least 1 preselected from parent dropdown. If more - it means that we've got preselected in url which has higher priority then rendering parameters
            facets.push(new FacetCascadedValue(id, val, parent, text, $el[0], isPreSelected, !isParentPreSelected));
        });

        $(".ipa-back", panelElement).on("click", function (e) {
            e.preventDefault();
            $(".score-button-menu", panelElement).removeClass("open");
        });

        Object.defineProperties(this, {
            scope: { value: panelElement },
            $scope: { value: $(panelElement) },
            defaultChooseText: { value: $dataEl.data("placeholder") },
            viewModel: { value: viewModel },
            title: { value: title },
            parent: { value: title },
            parentFacet: { value: null, writable: !0, configurable: !0 },
            titleText: { value: titleText },
            searchLogicType: { value: searchLogic.indexOf(searchLogicType) },
            facets: { get: Array.prototype.slice.bind(facets) },
            asString: {
                get: function () {
                    var selectedFacets = facets.filter(function (facet) { return facet.selected(); });
                    var result = selectedFacets.map(function(facet) { return facet.value; }).join('|');

                    if (!result) {
                        if (viewModel.selectedOptionText() !== initialSelectedOptionText) {
                            viewModel.selectedOptionText(initialSelectedOptionText);
                        }
                        viewModel.isAnySelected(false);
                        return null;
                    }

                    if (selectedFacets.length > 1) {
                        viewModel.selectedOptionText(selectedFacets[0].text + ' (+' + (selectedFacets.length -1) + ')');
                    } else if (selectedFacets.length === 1) {
                        viewModel.selectedOptionText(selectedFacets[0].text);
                    } else {
                        viewModel.selectedOptionText(result);
                    }
                    viewModel.isAnySelected(true);
                    return this.title + ":" + result;
                }
            }
        });

        // event will be fired by this facet as the parent Facet will be found. Event will be fired by this.waitForParent() method.
        // After that we can subscribe to the parent updates and track them to reflect current facet, which depends on the parent.
        $(this).on('parentFound', this._parentFacetFoundHandler.bind(this));
        this.waitForParent();

        // decorate with KO just for this instance.
        this.selectedValues = ko.pureComputed(this.selectedValues.bind(this));

        // store instance of facet in data, to prevent twice initialization.
        $(panelElement).data('facet', this);

        eventManager.subscribe("search-empty", function () {
            if (self.selectedValues().length < 1) {
                viewModel.isDisabledDropdownButton(true);
            }
        });

        eventManager.subscribe("search-rendered", function (scope) {
            if ($(scope).is(":visible")) {
                viewModel.isDisabledDropdownButton(false);
            }
        });
    }

    FacetCascadedPanel.prototype.selectValues = function selectValues(selectedValues) {
        var selectedByTitle = selectedValues[this.title] || "";
        this.facets.forEach(function (facet) {
            var oldValue = facet.selected();
            var newValue = selectedByTitle.indexOf(facet.value) > -1;
            if (oldValue !== newValue) {
                facet.selected(selectedByTitle.indexOf(facet.value) > -1);
            }
        });
    }

    /*
     * Returns all selected facets.
     */
    FacetCascadedPanel.prototype.selectedValues = function selectedValues() {
        return this.facets.filter((function (facet) {
            return facet.selected() ? facet : null;
        }).bind(this));
    }

    /*
     * Unselect all nested facets.
     */
    FacetCascadedPanel.prototype.unselectAll = function unselectAll() {
        this.selectedValues().forEach(function (facet) {
            facet.selected(false);
            facet.disabled(true);
        });

        this.viewModel.selectedOptionText(this.defaultChooseText);
        this.viewModel.isDisabledDropdownButton(true);
    };


    /*
     * Wait for the parent to be initialized.
     */
    FacetCascadedPanel.prototype.waitForParent = function waitForParent() {
        this.waitForParentInterval = setInterval((function waitForParentInterval() {
            var parentFacet = this.$scope.closest('.score-facet-container').find('>.score-facet-panel')
                .map(function (i, el) {
                    var facetEntity = $(el).data('facet');
                    return facetEntity != null && facetEntity.title === this.title && !facetEntity.parent ? facetEntity : null;
                }.bind(this)
                ).get(0);

            if (parentFacet != null) {
                // cleanup interval, to prevent feature logic call, but still need to be in condition, 
                // in case if the prev logic iteration was not ended.
                if (this.waitForParentInterval) { clearInterval(this.waitForParentInterval); }

                // save parent facet to the instance variable
                this.parentFacet = parentFacet;

                $(this).trigger('parentFound', [this, parentFacet]);
            }
        }).bind(this),
            50 /* kind of a standard to check the DOM */);
    }

    FacetCascadedPanel.prototype._parentFacetFoundHandler = function _parentFacetFoundHandler() {
        if (this.parentFacet == null) {
            throw new Error("Could not find a parent facet for the facet with id: " + this.scope.getAttribute('data-id'));
        }

        if (!(this.parentFacet.selectedValues instanceof Function) || !(this.parentFacet.selectedValues.subscribe instanceof Function)) {
            throw new Error("Could not subscribe the the parent facet selected values update. Parent Facet doesn't have 'selectedValues' method. FacetId: " + this.scope.getAttribute('data-id'));
        }

        this.trackParentUpdates();

        // track feature updates received from the parent facet.
        this.parentFacet.selectedValues.subscribe(this.trackParentUpdates.bind(this));
    }

    FacetCascadedPanel.prototype.trackParentUpdates = function trackParentUpdates() {
        var parentSelection = this.parentFacet.asString;
        if (!parentSelection) {
            this.unselectAll();
            return;
        }

        // we expect from the parent facet the next format: FacetTitle:Value|Value|Value|Value
        var selectedValues = parentSelection.split(':').slice(-1)[0].split('|');
        if (!selectedValues.length) {
            this.unselectAll();
            return;
        }

        // go though the list of the current facet elements, and activate/disable facet elements which reflect to the selected parent
        this.facets.forEach((function (facet) {
            if (facet.disabled() != !~selectedValues.indexOf(facet.parent)) {
                facet.disabled(!~selectedValues.indexOf(facet.parent));
            }

            // if facet is disabled, we also have to remove selection
            if (facet.disabled() && facet.selected()) {
                facet.selected(!1);
            }
        }).bind(this));

        // if none of facets are active, then we should disabled the current dropdown.
        var isDropdownActive = this.facets.filter((function (facet) { return facet.disabled() ? null : facet; }).bind(this)).length > 0;
        this.viewModel.isDisabledDropdownButton(!isDropdownActive);
    }


    return FacetCascadedPanel;
});
